// A very simple file with no circular dependencies for HMR.

export const primaryButtonClass =
    "rounded-lg bg-purple-100 px-2.5 py-0.75 text-[13px] font-medium text-gray-900 ring-1 ring-inset ring-purple-100 hover:bg-gray-50";
export const secondaryButtonClass =
    "rounded-lg bg-gray-100 px-2.5 py-0.75 text-[13px] font-medium text-gray-900 ring-1 ring-inset ring-gray-100 hover:bg-gray-50";

export const abortButtonClass =
    "rounded-lg bg-rose-50 px-2.5 py-0.75 text-[13px] font-medium text-gray-900 ring-1 ring-inset ring-gray-100 hover:bg-gray-50";

export const dayFormStyles = {
    row: "flex text-center",
    label: "flex-1 whitespace-nowrap border-0 min-w-[31%] text-right font-medium self-center mr-[3px]",
    firstHeader: "flex-1 min-w-[31%]",
    header: "flex-1 font-medium min-w-[23%] text-center",
    total: "flex-1 min-w-[23%]",
    target: "day-target flex-1 min-w-[23%]",
    remaining: "flex-1 min-w-[23%]",
    optionalSection: "",
    optionalRow: "flex text-right",
    optionalLabel:
        "flex-1 whitespace-nowrap min-w-[31%] font-medium text-xs overflow-hidden text-ellipsis",
    optionalMacro: "flex-1 whitespace-nowrap min-w-[23%] text-center text-xs",
} as const;

export const ratingRequestClass =
    "rating-request animate-[flip-in-x_1s] w-full my-2.5 mx-auto bg-[#d9edf7] text-[#1a4b6b]";

export const migrateClass =
    "border-b border-[#D8D8D8] p-2.5 flex flex-col gap-1.5 items-center";
